<div
  class="offcanvas offCanvasStart offcanvas-start"
  tabindex="-1"
  id="availableDatasets"
  aria-labelledby="availableDatasets"
>
  <div class="offcanvas-header">
    <div class="w-100">
      <div class="d-flex justify-content-between">
        <h2>Available Datasets</h2>
        <button
          type="button"
          class="btn btn-secondary btn-icon-only"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          (click)="resetSearch()"
        >
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="d-flex">
        <label class="form-label" for="filterAvailableDatasets">Filter by theme or country</label>
      </div>

      <div class="input-group mb-3 shadow">
        <input
          class="form-control border-0"
          id="filterAvailableDatasets"
          type="text"
          autocomplete="off"
          [(ngModel)]="searchTerm"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onFieldChange($event)"
        />
        <button type="button" class="btn btn-secondary btn-icon-only" (click)="resetSearch()">
          <i class="bi bi-search" aria-label="Search" *ngIf="!searchTerm.trim().length"></i>
          <i class="bi bi-x-lg" aria-label="Clear Search" *ngIf="searchTerm.trim().length > 0"></i>
        </button>
      </div>
      <p class="m-0" *ngIf="searchTerm.length && filteredDatasets.length">
        Showing {{ filteredDatasets.length }} of {{ datasets.length }} datasets for search term:
        <strong>{{ searchTerm }}</strong>
      </p>
      <p class="m-0" *ngIf="searchTerm.length && !filteredDatasets.length">
        No results for search term:
        <strong>{{ searchTerm }}</strong>
      </p>
      <p class="m-0" *ngIf="searchTerm.length === 0">
        Showing {{ filteredDatasets.length }} of {{ datasets.length }} datasets
      </p>
    </div>
  </div>
  <div class="offcanvas-body">
    <div class="w-100" id="scrollContainerTop">
      <ul class="list-unstyled" *ngIf="!loading">
        <li class="card mb-3 shadow" *ngFor="let dataset of filteredDatasets">
          <div class="row g-0">
            <div class="col-3">
              <img
                src="../../assets/els/images/datasets/portrait/{{ dataset.mapServiceURLSlug }}.jpg"
                srcset="
                  ../../assets/els/images/datasets/portrait/{{dataset.mapServiceURLSlug}}@2x.jpg 2x
                "
                class="img-fluid"
                alt="{{ dataset.name }}"
                width="222"
                height="90"
              />
            </div>
            <div class="col-9 d-flex flex-column justify-content-between">
              <div class="card-body">
                <h3 class="card-title" [innerHTML]="dataset.name"></h3>
                <p class="card-text" [innerHTML]="dataset.mapServiceDescription"></p>
              </div>
              <div class="d-flex justify-content-end card-cta">
                <a
                  routerLink="/datasets/{{ dataset.mapServiceURLSlug }}"
                  class="btn btn-secondary text-nowrap"
                >
                  More Info
                  <span class="sr-only">about {{ dataset.name }}</span>
                  <i class="bi bi-info-circle"></i>
                </a>
                <a
                  routerLink="/explore-map/{{ dataset.mapServiceURLSlug }}"
                  class="btn btn-secondary text-nowrap ms-1"
                  [ngClass]="{
                    active: dataset.mapServiceURLSlug === activeMapServiceSlug
                  }"
                >
                  View
                  <span class="sr-only">{{ dataset.name }} Dataset</span>on Map
                  <i class="bi bi-globe"></i>
                </a>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="d-flex justify-content-between px-3 py-2 py-sm-3">
    <a class="btn btn-secondary" routerLink="/access-data">
      Access Data
      <i class="bi bi-cloud-arrow-down"></i>
    </a>
    <app-back-to-top target="scrollContainerTop"></app-back-to-top>
  </div>
</div>
